import { createRouter, createWebHistory } from 'vue-router'
import generatedRoutes from 'virtual:generated-pages'
import { setupLayouts } from 'virtual:generated-layouts'
import { setRouter, canUserAccess } from '@nitra/vite-boot/router'
import { cleanToken } from '@nitra/vite-boot/token'

const routes = setupLayouts(generatedRoutes)

// Шлях за умовчанням
// routes.push({ path: '', redirect: '/' })

// Функція виходу
routes.push({
  path: '/logout',
  redirect: () => {
    // Записуємо поточний урл в session storage
    // щоб потім на нього повернути після логіну
    sessionStorage.setItem('url-before-logout', router.currentRoute.value.path)
    cleanToken()
    return '/login'
  }
})

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, _from) => {
  const canAccess = canUserAccess(to)

  if (!canAccess) {
    return '/login'
  }
})

setRouter(router)
